import * as React from "react";
import { Select } from "antd";
const Option = Select.Option;
import { connect } from "react-redux";

interface IAreaProps {
  width?: number;
  share?: any;
  value?: any;
  "data-field"?: any;
  onChange?: any;
}

class Area extends React.Component<IAreaProps, any> {
  constructor(props: IAreaProps) {
    super(props);
  }

  onChangeArea = e => {
    // 把选择的地区信息，抛到父级组件
    this.props.onChange && this.props.onChange(e, this.props["data-field"]);
  };

  render() {
    const list = this.props.share.area || [];
    const mapList = () => {
      let options: any = [];
      for (const item of list) {
        options.push(
          <Option key={item.id} value={item.area_name}>
            {item.area_name}
          </Option>
        );
      }
      return options;
    };

    // 当数据已加载完成时才设置选中的值
    const value = this.props.share.area.length
      ? this.props.value || undefined
      : undefined;

    // 根据关键字检索option
    const filter = (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return (
      <Select
        style={{ width: this.props.width || 200 }}
        value={value}
        allowClear={true}
        placeholder="选择地区"
        onChange={this.onChangeArea}
        // 检索相关
        showSearch
        optionFilterProp="children"
        filterOption={filter}
        // 检索相关
      >
        {mapList()}
      </Select>
    );
  }
}

const mapState = state => ({
  share: state.share
});

export default connect(
  mapState,
  null
)(Area);
